import * as React from "react";

import {
    INotificationsContext,
    NotificationsContext,
} from "./notificationContext";


export interface WithNotifications {
    notificationContext: INotificationsContext;
}

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const withNotifications = <P extends WithNotifications>(Component: React.ComponentType<P>) => {
    return class extends React.Component<Omit<P, keyof WithNotifications>> {
        render() {
            const { ...props } = this.props;
            return (
                <NotificationsContext.Consumer>
                    {value => <Component notificationContext={value} {...(props as P)} />}
                </NotificationsContext.Consumer>
            );
        }
    };
};
